const _chaveSessionStorageGeoData = 'localizacaoGeoData';
const _ttlGeoDataMs = 6 * 60 * 60 * 1000; // 6h: reavalia a geo sem regravar a cada pagina

export function setGeoData(geoData) {
    // cidade vazia ('' quando os headers cf-* nao chegam, ex.: acesso direto sem Cloudflare) nao pode ser gravada:
    // vira geo "existente" porem inutil e os consumidores renderizam chips/blocos vazios
    if (geoData == null || !geoData.cidade) {
        return;
    }

    //Decodifica string
    let geoDataCidadeDecode = decodeURIComponent(geoData.cidade);
    //Retira caracteres ainda estranhos
    geoDataCidadeDecode = geoDataCidadeDecode.replace(/£/g, '').replace(/Ã/g, 'ã').replace(/Â/g, 'â').replace(/Ê/g, 'ê').replace(/Î/g, 'î').replace(/Ô/g, 'ô').replace(/Û/g, 'û').replace(/Á/g, 'á').replace(/É/g, 'é').replace(/Í/g, 'í').replace(/Ó/g, 'ó').replace(/Ú/g, 'ú');
    geoData.cidade = geoDataCidadeDecode;

    // antes a geo era gravada 1x e nunca mais (quem mudava de cidade ficava preso na antiga);
    // agora regrava quando a cidade recebida difere da armazenada ou quando o TTL vence
    let geoAtual = null;
    try { geoAtual = JSON.parse(localStorage.getItem(_chaveSessionStorageGeoData)); } catch (e) { /* valor corrompido: regrava */ }
    const mudouCidade = !geoAtual || geoAtual.cidade !== geoData.cidade;
    const expirou = !geoAtual || !geoAtual._ts || (Date.now() - geoAtual._ts) > _ttlGeoDataMs;
    if (!mudouCidade && !expirou) {
        return;
    }

    geoData._ts = Date.now();
    localStorage.setItem(_chaveSessionStorageGeoData, JSON.stringify(geoData));
}

export function getGeoData() {
    if (!localStorage.getItem(_chaveSessionStorageGeoData)) {
        return { existe: false };
    }

    const geoDataParsed = JSON.parse(localStorage.getItem(_chaveSessionStorageGeoData));
    const nomeCidade = `${geoDataParsed.cidade}, ${geoDataParsed.regiaoCodigo}, ${geoDataParsed.pais}`;

    return { existe: true, data: geoDataParsed, cidadeCompleta: nomeCidade };
}